export const PHONE_MASK = '(000) 000-0000'

export const PHONE_EXTENSION_MASK = '0000'
